import React from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/css/bootstrap.css';
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from 'react-router-dom';

import Navibar from './components/navibar/navibar.jsx';
import Footer from './components/footer/footer.jsx';
import './styles/global.css'; 

import { Home } from './pages/home/home.jsx';
import { Catalog } from './pages/catalog/catalog.jsx';
import { About } from './pages/about/about.jsx';
import { WorkArea } from './pages/work-area/work-area.jsx';
import { Admin } from './pages/admin/admin.jsx';
import { Edit } from './pages/admin/edit/edit.jsx';
import { Price } from './pages/admin/price/price.jsx';
import { Stat } from './pages/admin/stat/stat.jsx';
import { Login } from './pages/admin/login/login.jsx';
import { AdminSlides } from './pages/admin/slides/slides.jsx';
import { AdminCategories } from './pages/admin/categories/categories.jsx';
import { AdminShowcase } from './pages/admin/showcase/showcase.jsx';

import ProtectedRoute from './components/protectedRoute/protectedRoute.jsx';

function LayoutWithGui() {
  const location = useLocation();
  // Скрываем шапку и футер для всего, что начинается с /admin
  const hideGui = location.pathname.startsWith('/admin');
  const navigate = useNavigate();

  const handleLogin = () => {
    navigate('/admin');
  };

  return (
    <>
      {!hideGui && <Navibar/>}
      <Routes>
        <Route path='/' element={<Home/>}/>
        <Route path='/catalog' element={<Catalog/>}/>
        <Route path='/about' element={<About/>}/>
        <Route path='/working-area' element={<WorkArea/>}/>
        
        {/* Чистые роуты админки */}
        <Route path='/admin/login' element={<Login onLogin={handleLogin}/>}/> 
        <Route path='/admin' element={
          <ProtectedRoute>
            <Admin/>
          </ProtectedRoute>
        }> 
          <Route path='edit' element={<Edit/>}/>
          <Route path='categories' element={<AdminCategories/>}/> {/* ДОБАВИТЬ ЭТО */}
          <Route path='slides' element={<AdminSlides/>}/>
          <Route path='showcase' element={<AdminShowcase/>}/>
          <Route path='price' element={<Price/>}/>
          <Route path='stat' element={<Stat/>}/>
        </Route>
      </Routes>
      {!hideGui && <Footer/>}
    </>
  );
}

function App() {
  return (
    <div data-bs-theme="light">
      <Router>
        <LayoutWithGui />
      </Router>
    </div>
  );
}

export default App;
